import { Injectable } from '@angular/core';
import { Firestore, CollectionReference, collection, orderBy, where, query, doc, docData, Query, limit } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TableMessage } from '../state/game/game.state';
import { FireSubService } from './fireSub.service';

@Injectable({ providedIn: 'root' })
export class GameService {
    constructor(
        private firestore: Firestore,
        private fireSubService: FireSubService
    ) {

    }

    getLastMessages(tableID: string): Query<TableMessage> {
        const collectionReference = collection(this.firestore, `tables/${tableID}/messages`) as CollectionReference<TableMessage>;
        const collectionQuery = query(collectionReference, orderBy('dateCreated', 'desc'), limit(10));
        return collectionQuery;
    }

    getTableMessages(tableID: string, lastMessageSentAt: Date): Query<TableMessage> {
        const collectionReference = collection(this.firestore, `tables/${tableID}/messages`);
        const collectionQuery = query(collectionReference, orderBy('dateCreated', 'desc'), where('dateCreated', '>', lastMessageSentAt)) as CollectionReference<TableMessage>;
        return collectionQuery;
    }

    exitTable() {

    }

    leaveTable(): Promise < void > {
        return Promise.resolve();
    }

    joinTable(): Promise < void > {
        return Promise.resolve();
    }

    getTableObservable(tableId: string): Observable<any> {
        const docReference = doc(this.firestore, `tables/${tableId}`);
        return docData(docReference)
            .pipe(
                takeUntil(this.fireSubService.unsubscriber),
                distinctUntilChanged(),
            )
    }

}
